import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "react-responsive-carousel/lib/styles/carousel.min.css";
//import Carousel from "react-material-ui-carousel";
import { Carousel } from "react-responsive-carousel";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SignInSection from "../../components/SignIn-section/SignInSection";

var items = [
  {
    name: "https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2FUntitled%20design.png?alt=media&token=92661765-245f-4559-be50-5b6972e8bf13",
    description: "Hello World!",
  },
  {
    name: "https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2Ffff.png?alt=media&token=060ff983-2943-4e6c-858a-bbbef6017822",
    description: "Hello World!",
  },
  {
    name: "https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2FUntitled%20design%20(1).png?alt=media&token=8be40705-200d-474e-8dd1-c1371df3f0e2",
    description: "Probably the most random thing you have ever seen!",
  },
  {
    name: "https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2FFFFF.png?alt=media&token=9b0eac9d-ebb8-492b-9163-31ae852ed4af",
    description: "Hello World!",
  },
  {
    name: "https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2Fft.png?alt=media&token=dba9bf17-8137-412f-9f90-7b2e881a0544",
    description: "Hello World!",
  },
];

const theme = createTheme();

export default function SignInSlide() {

  let navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        component="main"
        sx={{ height: "100vh", overflow: { md: "hidden" } }}
      >
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            display: { md: "flex", xs: "none" },
          }}
        >
          <Carousel
           showThumbs={false} 
            autoPlay={true}
            interval={2000}
            animationHandler="fade"
            infiniteLoop={true}
          >
            {items.map((item, i) => (
              <Item key={i} item={item} />
            ))}
          </Carousel>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              border:"none",
              width: "20px",
              height: "60px",
            }}
            onClick={() => navigate("/")}
          >
            Home
          </Button>
          <SignInSection />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

function Item(props) {
  const { item } = props;
  return (
    <Box component="div">
      <Box
        component="img"
        sx={{
          height: "100vh",
          width: "100%",
          backgroundRepeat: "no-repeat",
          objectFit: "cover",
          objectPosition: "left",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        src={item.name}
        alt="random"
      ></Box>
    </Box>
  );
}
